import React from "react";
import classNames from "classnames";
import styles from "./TechCard.module.scss";
import { GradientIcon } from "../gradient-icon/GradientIcon.component";

interface TechCardProps {
  title: string;
  icon?: string;
  iconElement?: React.ReactNode;
  iconViewBox?: string;
  children: React.ReactNode;
  className?: string;
}

export const TechCard: React.FC<TechCardProps> = ({
  title,
  icon,
  iconElement,
  iconViewBox = "0 0 24 24",
  children,
  className,
}) => {
  return (
    <div className={classNames(styles["tech-card"], className)}>
      <div className={styles["header"]}>
        {iconElement && (
          <div className={styles["icon-wrapper"]}>{iconElement}</div>
        )}
        {icon && !iconElement && (
          <div className={styles["icon-wrapper"]}>
            <GradientIcon path={icon} viewBox={iconViewBox} />
          </div>
        )}
        <h2>{title}</h2>
      </div>
      <div className={styles["content"]}>{children}</div>
    </div>
  );
};
